import React, { useState } from 'react';
import { View, Text, Pressable } from 'react-native';
import theme from '../../theme';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const FAQS = [
  {
    q: 'Which warehouses and sources do you support?',
    a: 'Whatever you already run — Snowflake, BigQuery, Redshift, Postgres, and the ad/CRM sources feeding them. We build to your stack rather than asking you to migrate to ours.',
  },
  {
    q: 'How long does it take to launch?',
    a: 'Most connections and a first working report ship within a couple of weeks — we scope exact timelines against your sources and access setup during onboarding.',
  },
  {
    q: 'Is a data processing agreement included?',
    a: 'Yes — a DPA is in place for every engagement by default, not on request.',
  },
  {
    q: 'How is this priced?',
    a: "Cost is structured around what you actually need — number of sources, data volume, and whether we're building in your existing BI tool or a custom front end — rather than a flat seat price.",
  },
];

export default function BusinessIntelligenceFAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <View
      style={{
        paddingHorizontal: theme.spacing.space12,
        paddingTop: theme.spacing.space10,
        paddingBottom: theme.spacing.space16,
        maxWidth: 760,
        alignSelf: 'center',
        width: '100%',
        borderTopWidth: theme.borderWidth.thin,
        borderTopColor: theme.colors.borderSubtle,
      }}
    >
      <Text
        style={{
          fontFamily: theme.typography.fontDisplay,
          fontWeight: theme.typography.weight.regular,
          fontSize: theme.typography.size['2xl'],
          letterSpacing: theme.trackingPx(theme.typography.size['2xl'], 'tight'),
          color: theme.colors.textPrimary,
          marginBottom: theme.spacing.space6,
        }}
      >
        FAQ
      </Text>

      {FAQS.map((item, i) => {
        const isOpen = i === openIndex;
        return (
          <Pressable
            key={item.q}
            onPress={() => setOpenIndex(isOpen ? -1 : i)}
            style={{
              borderBottomWidth: theme.borderWidth.thin,
              borderBottomColor: theme.colors.borderDefault,
              paddingVertical: theme.spacing.space4 + 2,
            }}
          >
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', gap: theme.spacing.space4 }}>
              <Text
                style={{
                  flex: 1,
                  fontFamily: theme.typography.fontBody,
                  fontWeight: theme.typography.weight.medium,
                  fontSize: theme.typography.size.base,
                  color: theme.colors.textPrimary,
                }}
              >
                {item.q}
              </Text>
              {isOpen ? (
                <RemoveIcon style={{ fontSize: 18, color: theme.colors.textTertiary, flexShrink: 0 }} />
              ) : (
                <AddIcon style={{ fontSize: 18, color: theme.colors.textTertiary, flexShrink: 0 }} />
              )}
            </View>
            {isOpen && (
              <Text
                style={{
                  fontFamily: theme.typography.fontBody,
                  fontSize: theme.typography.size.sm,
                  color: theme.colors.textSecondary,
                  lineHeight: theme.lineHeightPx(theme.typography.size.sm, 'normal'),
                  marginTop: theme.spacing.space3,
                  maxWidth: 620,
                }}
              >
                {item.a}
              </Text>
            )}
          </Pressable>
        );
      })}
    </View>
  );
}
